<template>
  <div class="first">
    <div class="header">
      <van-nav-bar>
        <template #left>
          <van-image
            :src="require('../../assets/img/logo.png')"
            height="2rem"
            width="2rem"
            @click=""
          />
        </template>
        <template #title style="margin-left: 15%">
          <van-row>{{ $t('webnames') }}</van-row>
        </template>
        <template #right>
          <van-popover
            v-model="showPopover"
            :actions="selectLangOption"
            placement="bottom-end"
            @select="onSelect"
          >
            <template #reference>
              <div
                class="nav_right"
                @click="
                  showPopover ? (showPopover = false) : (showPopover = true)
                "
              >
                {{ showname }}
                <div class="action"></div>
                <img
                  v-if="!showPopover"
                  alt=""
                  src="../../assets/img/arrow_down.36c10fef.svg"
                />
                <img
                  v-else
                  alt=""
                  src="../../assets/img/arrow_up.4af92010.svg"
                />
              </div>
            </template>
          </van-popover>
        </template>
      </van-nav-bar>
    </div>
    <div class="content" data-v-2d9d6322="">
      <div class="new-feature" data-v-2d9d6322="" dir="auto">
        <div class="left-bg1" data-v-2d9d6322=""></div>
        <div class="left-bg2" data-v-2d9d6322=""></div>
        <div class="titles" data-v-2d9d6322="">
          <div class="balance" data-v-2d9d6322="">
            <img
              alt=""
              data-v-2d9d6322=""
              src="../../assets/img/balance.0dce5020.svg"
            />
          </div>
          {{ $t('accountbance') }}
        </div>
        <div class="banalce-info" data-v-2d9d6322="">
          <div data-v-2d9d6322="" style="display: inline">
            ${{ userinfo.uinfo.usdtbalance }}
          </div>
          <span data-v-2d9d6322="" dir="ltr"></span>
        </div>
        <div class="infos" data-v-2d9d6322="">
          <div class="info" data-v-2d9d6322="">
            <div class="info-title" data-v-2d9d6322="">
              {{ $t('todayprofit') }}
            </div>
            <div class="info-content" data-v-2d9d6322="" dir="ltr">
              $ {{ userinfo.lcprofit }}
            </div>
          </div>
          <div class="info" data-v-2d9d6322="">
            <div class="info-title" data-v-2d9d6322="">{{ $t('aiquat') }}</div>
            <div class="info-content" data-v-2d9d6322="" dir="ltr">
              $ {{ userinfo.lcmoney }}
            </div>
          </div>
          <div class="info" data-v-2d9d6322="">
            <div class="info-title" data-v-2d9d6322="">{{ $t('roi') }}</div>
            <div class="info-content" data-v-2d9d6322="" dir="ltr">0.00%</div>
          </div>
        </div>
      </div>
      <div class="coin-buttons-list" data-v-e6db21c0="">
        <div
          class="coin-button-big coin-button-big1"
          data-v-e6db21c0=""
          v-for="items in product"
          style="margin-right: 5px"
          @click="totrade(items.gcode)"
        >
          <div class="coin-title" data-v-e6db21c0="">
            {{ items.name }}
          </div>
          <div class="coin-address" data-v-e6db21c0="">
            {{ items.fullname }}
          </div>
          <div class="coin-number-info" data-v-e6db21c0="">
            <div class="upstyle" data-v-e6db21c0="">
              <span data-v-e6db21c0="">{{ items.change }}</span
              ><span data-v-e6db21c0="">%</span>
            </div>
            <div class="number-info-arrow" data-v-e6db21c0="">
              <img
                v-if="items.change > 0"
                :src="
                  require('../../assets/img/up_arrow.05a4c908-32913ec4.svg')
                "
                alt=""
                data-v-e6db21c0=""
              />
              <img
                v-else
                :src="
                  require('../../assets/img/down_arrow.72e387a2-d4fc992a.svg')
                "
                alt=""
                data-v-e6db21c0=""
              />
            </div>
          </div>
          <!---->
        </div>
        <!--        <div-->
        <!--          class="coin-button-big coin-button-big1 coin-left"-->
        <!--          data-v-e6db21c0=""-->
        <!--        >-->
        <!--          <div class="coin-title" data-v-e6db21c0="">-->
        <!--            {{ product[1]['name'] }}-->
        <!--          </div>-->
        <!--          <div class="coin-address" data-v-e6db21c0="">-->
        <!--            {{ product[1]['fullname'] }}-->
        <!--          </div>-->
        <!--          &lt;!&ndash;&ndash;&gt;-->
        <!--          <div class="coin-number-info" data-v-e6db21c0="">-->
        <!--            <div class="lower" data-v-e6db21c0="">-->
        <!--              <span data-v-e6db21c0="">{{ product[1]['change'] }}</span-->
        <!--              ><span data-v-e6db21c0="">%</span>-->
        <!--            </div>-->
        <!--            <div class="number-info-arrow" data-v-e6db21c0="">-->
        <!--              <img-->
        <!--                v-if="product[1].change > 0"-->
        <!--                :src="-->
        <!--                  require('../../assets/img/up_arrow.05a4c908-32913ec4.svg')-->
        <!--                "-->
        <!--                alt=""-->
        <!--                data-v-e6db21c0=""-->
        <!--              />-->
        <!--              <img-->
        <!--                v-else-->
        <!--                :src="-->
        <!--                  require('../../assets/img/down_arrow.72e387a2-d4fc992a.svg')-->
        <!--                "-->
        <!--                alt=""-->
        <!--                data-v-e6db21c0=""-->
        <!--              />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="coin-button-big coin-button-big1 coin-left"-->
        <!--          data-v-e6db21c0=""-->
        <!--        >-->
        <!--          <div class="coin-title" data-v-e6db21c0="">-->
        <!--            {{ product[2]['name'] }}-->
        <!--          </div>-->
        <!--          <div class="coin-address" data-v-e6db21c0="">-->
        <!--            {{ product[2]['fullname'] }}-->
        <!--          </div>-->
        <!--          &lt;!&ndash;&ndash;&gt;-->
        <!--          <div class="coin-number-info" data-v-e6db21c0="">-->
        <!--            <div class="lower" data-v-e6db21c0="">-->
        <!--              <span data-v-e6db21c0="">{{ product[2]['change'] }}</span-->
        <!--              ><span data-v-e6db21c0="">%</span>-->
        <!--            </div>-->
        <!--            <div class="number-info-arrow" data-v-e6db21c0="">-->
        <!--              <img-->
        <!--                v-if="product[2].change > 0"-->
        <!--                :src="-->
        <!--                  require('../../assets/img/up_arrow.05a4c908-32913ec4.svg')-->
        <!--                "-->
        <!--                alt=""-->
        <!--                data-v-e6db21c0=""-->
        <!--              />-->
        <!--              <img-->
        <!--                v-else-->
        <!--                :src="-->
        <!--                  require('../../assets/img/down_arrow.72e387a2-d4fc992a.svg')-->
        <!--                "-->
        <!--                alt=""-->
        <!--                data-v-e6db21c0=""-->
        <!--              />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div data-v-e6db21c0="" class="goods-markets-box">
        <div data-v-e6db21c0="" class="goods-markets-title">
          <span data-v-e6db21c0="" style="color: rgb(255, 255, 255)">{{
            $t('market')
          }}</span
          ><span data-v-e6db21c0="" class="goods-more" @click="tomarket">{{
            $t('seemore')
          }}</span>
        </div>
        <div data-v-e6db21c0="">
          <div
            data-v-e6db21c0=""
            class="markets-main-list"
            v-for="(item, index) in product"
            @click="totrade(item.gcode)"
          >
            <div data-v-e6db21c0="" class="markets-icon markets-icon1">
              <img
                data-v-e6db21c0=""
                class="imgs-icon1 goods-icon1"
                :src="item.logo"
                alt=""
                srcset=""
              />
              <div data-v-e6db21c0="" class="markets-name">
                {{ item.name }}
                <div data-v-e6db21c0="" class="names">{{ item.fullname }}</div>
              </div>
            </div>
            <div data-v-e6db21c0="" class="markets-chart">
              <mytrend2
                :n5data="item.kdata"
                :productid="item.id"
                :linecolor="item.change > 0 ? '#c2e22a' : '#ce7735'"
              />
            </div>
            <div data-v-e6db21c0="" class="markets-number">
              <span data-v-e6db21c0="" id="btcusdt_price">{{
                item.close
              }}</span>
              <div
                data-v-e6db21c0=""
                class="rersult_succsee"
                id="btcusdt_change"
                v-if="item.type"
              >
                {{ item.change }}%
              </div>
              <div
                data-v-e6db21c0=""
                class="rersult"
                id="btcusdt_change"
                v-else
              >
                {{ item.change }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="strategy" data-v-2d9d6322="" dir="auto">
        <div class="strategy-icon" data-v-2d9d6322="">
          <img
            alt=""
            data-v-2d9d6322=""
            src="../../assets/img/saleCoin.6d24a7ae.svg"
          />
        </div>
        <div class="strategy-text" data-v-2d9d6322="">
          {{ $t('comesoon') }}
        </div>
        <div class="strategy-text1" data-v-2d9d6322="">
          {{ $t('newcoin') }}
        </div>
        <div class="strategy-text" data-v-2d9d6322="">
          {{ $t('inshuzi') }}
        </div>
        <div class="strategy-button" data-v-2d9d6322="">{{ $t('buy') }}</div>
      </div>
      <div class="strategy" data-v-2d9d6322="" dir="auto">
        <div class="strategy-icon" data-v-2d9d6322="">
          <img
            alt=""
            data-v-2d9d6322=""
            src="../../assets/img/trading.60cebfaa.svg"
          />
        </div>
        <div class="strategy-text" data-v-2d9d6322="">{{ $t('simple') }}</div>
        <div class="strategy-text1" data-v-2d9d6322="">
          {{ $t('aitrade') }}
        </div>
        <div class="strategy-text" data-v-2d9d6322="">
          {{ $t('safe') }} / {{ $t('wending') }} / {{ $t('simples') }}
        </div>
        <div class="strategy-button" data-v-2d9d6322="" @click="toai">
          <img
            alt=""
            data-v-2d9d6322=""
            src="../../assets/img/icon_add.df32452b.svg"
          />{{ $t('createtrade') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mytrend from '@/components/trend.vue'
import mytrend2 from '@/components/trend2.vue'
import '../../assets/css/index-c925edae.css'
// import '../../assets/css/365.4cc7e719.css'
// import '../../assets/css/800.c85b4727.css'
// import '../../assets/css/app.0f603e87.css'
import { Toast } from 'vant'
import empty from '@/views/index/empty.vue'

// setCookie('googtrans', '/auto/en', 100)
export default {
  components: {
    mytrend,
    mytrend2,
  },
  data() {
    return {
      tanchuang: false,
      selectLang: '',
      showPopover: false,
      timer: null,
      usertype: 1,
      actions: [{ text: '选项一' }, { text: '选项二' }, { text: '选项三' }],
      notice: '',
      selectLangOption: [
        {
          text: '',
          value: '1',
        },
        // {
        //   text: '模拟账户',
        //   value: '2',
        // },
      ],
      lang: localStorage.getItem('lang') || 'zh',
      search: '',
      level: '',
      popshow: false,
      indexData: {
        notice: [''],
      },
      product: [],
      product2: [],
      serverurl: '',
      user: {},
      suiji: false,
      editpass: {
        oldpass: '',
        newpass: '',
        newpass2: '',
      },
      msgcount: 0,
      notifyshow: false,
      websocket: null,
      wk: null,
      active: 0,
      userinfo: [],
      showname: '',
      useradress: '',
    }
  },
  created() {
    if (localStorage.getItem('lang') == 'false') {
      localStorage.setItem('lang', 'en')
    }
    this.getuserinfo()
    this.getdata()
    this.getdatas()
    this.timer = setInterval(this.getdata, 2000)
    // this.getmsgcount()
  },
  mounted() {
    // this.initwk()
  },
  beforeRouteLeave(to, from, next) {
    next()
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 切换账号
    async onSelect(action) {
      let lang = action.value
      if (lang == '2') {
        const { data } = await this.$http.post('/imitateloginpost', {
          address: this.useradress,
          clientip: '',
          currentDomain: window.location.hostname,
        })
        if (data) {
          if (data.code === '200') {
            window.localStorage.setItem('token', data.data.token)
            await this.getuserinfo()
          }
        }
      }
      if (lang == '1') {
        const { data } = await this.$http.post('/login', {
          address: this.useradress,
          Invite: '',
          currentDomain: window.location.hostname,
          clientip: '',
        })
        if (data) {
          if (data.code === '200') {
            window.localStorage.setItem('token', data.data.token)
            await this.getuserinfo()
          } else {
            this.$toast.fail(this.getlang(data.msg, this.lang))
          }
        }
      }
    },
    async getuserinfo() {
      const { data } = await this.$http.post('/getuserinformation')
      if (data) {
        if (data.code === '200') {
          this.userinfo = data.data
          if (data.data.uinfo.type === 1) {
            this.showname = data.data.uinfo.address.substring(0, 9)
            this.useradress = data.data.uinfo.address
          } else {
            this.showname = '模拟账户'
            this.useradress = data.data.uinfo.address
          }
          if (this.useradress) {
            this.selectLangOption[0].text = this.useradress.substring(0, 9)
          }
        }
      }
    },
    // 获取未读信息数

    // 获取首页数据
    async getdata() {
      const { data } = await this.$http.post('/cryptolist')
      if (data) {
        if (data.code === '200') {
          this.product = data.data
        }
      }
    },
    async getdatas() {
      const { data } = await this.$http.post('/cryptolists')
      if (data) {
        if (data.code === '200') {
          this.product2 = data.data
          console.log(this.product2)
        }
      }
    },
    // async getdatas() {
    //   const { data } = await this.$http.post('/cryptolist')
    //   if (data) {
    //     if (data.code === '200') {
    //       this.product2 = data.data
    //
    //       data.data.forEach(function (val, index) {
    //         setkdatas(index, val.gcode)
    //       })
    //     }
    //   }
    // },
    //
    // async setkdatas(index, code) {
    //   const { data } = await this.$http.post('/getsymbolsmallkline', {
    //     symbol: code,
    //   })
    //   if (data) {
    //     if (data.code) {
    //       that.product2[index]['kdata'] = data.data.lines
    //     }
    //   }
    // },
    openside() {
      this.popshow = true
    },
    tomarket() {
      this.$router.push('/news')
    },
    totrade(symbol) {
      this.$router.push({ path: '/trade', query: { symbol: symbol } })
    },
    // 去理财页
    toproduct(sym) {
      this.$router.push('/fund', { s })
    },
    closetanchuang() {
      this.tanchuang = false
    },
    // 去设置页
    toai() {
      this.$router.push('/fund')
    },
    // 客服链接
    toservice() {
      window.location.href = this.serverurl
    },
    // 退出
    logout() {
      window.localStorage.removeItem('token')
      this.$router.push('/login')
    },
    selectLangChange(value) {
      this.$i18n.locale = value
      localStorage.setItem('lang', value)
    },
    // 切换语言
    Language() {
      // function setCookie(cname, cvalue, exdays) {
      //   var d = new Date()
      //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      //   var expires = 'expires=' + d.toUTCString()
      //   document.cookie = cname + '=' + cvalue + '; ' + expires
      // }
      // setCookie('googtrans', '', -1111111111111)
      setCookie('googtrans', '/auto/en', 100)
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'en'
        localStorage.setItem('lang', 'en')
        // setCookie('googtrans', '/auto/en', 100)
      } else {
        this.$i18n.locale = 'zh'
        localStorage.setItem('lang', 'zh')
        // setCookie('googtrans', '/auto/zh', 100)
      }
      window.location.reload()
    },
    // 初始化连接
    initwebsocket() {
      this.websocket = new WebSocket(this.wsurl + '/wss:8881')
      this.websocket.onmessage = this.websocketonmessage
      this.websocket.onerror = this.websocketonerror
    },
    // 连接错误
    websocketonerror() {
      this.initwebsocket()
    },
    // 接收到数据
    websocketonmessage(e) {
      const message = JSON.parse(e.data)
      switch (message.type) {
        case 'init':
          this.binduid()
          break
        case 'text':
          this.getmsgcount()
          break
        case 'image':
          this.getmsgcount()
          break
      }
    },
    // 绑定uid
    binduid() {
      const msg = {
        type: 'bind',
        userid: this.user.id,
      }
      this.websocketsend(JSON.stringify(msg))
    },
    // websorcket发送信息
    websocketsend(data) {
      this.websocket.send(data)
    },
    closenotify() {
      this.notifyshow = false
    },
    initwk() {
      this.wk = new WebSocket(this.wsurl + '/wssss:8081')
      this.wk.onmessage = this.wkonmessage
    },
    wkonmessage(e) {
      try {
        const data = JSON.parse(e.data)
        // console.log('行情:', data)
        // console.log(this.product)
        for (let key in data) {
          if (data[key] && this.product) {
            data[key].pid = this.product[key].pid
          }
        }
        this.product = data
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .van-popover__content {
  background-color: #1a1a1a;
  box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);
}

.header {
  width: 100%;

  .van-search__content--round {
    height: 2rem;
  }

  .nav_right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 8.6rem;
    height: 2.5rem;
    border-radius: 0.6rem;
    background: #1a1a1a;
    position: relative;
    color: #ffffff;
    padding-left: 0.8rem;
    font-size: 14px;

    .action {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: 500;
      font-size: 0.14rem;
      margin-left: 0.12rem;
      margin-right: 0.12rem;
    }

    img {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.7rem;
    }
  }

  /deep/ .van-search {
    padding: 0;
  }

  /deep/ .van-icon {
    color: #b2b2b2;
  }

  /deep/ .van-nav-bar__right {
    font-size: 1.5rem;
  }

  /deep/ .van-nav-bar {
    position: relative;
    z-index: 1;
    line-height: 22px;
    text-align: left;
    background-color: #000;
    -webkit-user-select: none;
    user-select: none;
  }

  /deep/ .van-nav-bar__title {
    max-width: 60%;
    margin-left: 16%;
    color: #323233;
    font-weight: 500;
    font-size: 20px;
  }

  /deep/ .van-nav-bar__content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 60px;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }

  .van-info {
    min-width: 18px;
    font-size: 14px;
  }
}

.maincontent {
  padding: 15px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  // 轮播图
  .first-swipe {
    height: 8rem;

    .van-swipe-item img {
      width: 94%;
    }
  }

  .van-notice-bar {
    width: 94%;
    margin-left: 3%;
    background-color: #1a1a1a;
    color: #fff;
    border-radius: 5px;
  }

  //三个产品
  .currency-information {
    margin: 0.53333rem 0.8rem 0.53333rem 0.8rem;
    line-height: 2.66667rem;
    font-size: 0.93333rem;
    display: flex;
    white-space: nowrap;
    overflow-x: auto;

    .information {
      flex-shrink: 0;
      margin-right: 0.53333rem;
      width: 9.6rem;
      height: 4.26667rem;
      padding: 0.4rem;
      background-color: #1a1a1a;
      line-height: 1.6rem;
      border-radius: 0.26667rem;
    }
  }

  // 快捷买币
  .currency {
    width: 94%;
    margin-left: 3%;
    background-color: #1a1a1a;
    border-radius: 0.26667rem;
    overflow: hidden;

    .currency-shopping {
      background-color: #1a1a1a;
      color: #fff;
      line-height: 1.46667rem;
      padding: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top-left-radius: 0.26667rem;
      border-top-right-radius: 0.26667rem;

      .currency-shopping-image {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .currency-shopping-left {
        font-size: 0.9333rem;
        text-align: left;
        padding-left: 0.8rem;

        span {
          font-size: 0.61333rem;
        }
      }
    }

    .currency-service-span {
      border-bottom-left-radius: 0.26667rem;
      border-bottom-right-radius: 0.26667rem;

      div {
        padding: 0.4rem;
        background-color: #fff;
        display: flex;
        align-items: center;
        text-align: left;

        .van-image {
          padding: 0;
        }

        .van-col {
          float: left;
          box-sizing: border-box;
          min-height: 1px;
        }

        span {
          font-size: 0.8rem;
          margin-left: 0.53333rem;
        }
      }
    }
  }

  // banner
  .banner-image {
    width: 94%;
    margin: 0.53333rem 3%;

    .van-image {
      position: relative;
      display: inline-block;
    }

    /deep/ .van-image__img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 0.53333rem !important;
    }
  }

  // 产品列表
  .currency-title {
    margin-top: 0.8rem;
    margin-bottom: 0.4rem;
    font-size: 0.8rem;
    color: #b2b2b2;
  }

  .currency-Increase {
    background-color: #1a1a1a;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    font-size: 0.86rem;
    height: 3.46667rem;
    border-bottom: 0.02667rem solid #9393931a;
    display: flex;
    align-items: center;

    .currency-btn {
      border: none;
      float: right;
      border-radius: 0.26667rem;
      width: 4.4rem;
      height: 2.13333rem;
      color: #fff;
      font-size: 0.8rem;
    }
  }
}

// 弹出层
.personage-head {
  height: 18%;
  display: flex;
  align-items: center;
  justify-content: center;

  .personage-head-image {
    margin-right: 5%;
  }

  .personage-head-span {
    text-align: left;
    font-size: 1.33333rem;
    line-height: 2.13333rem;
  }
}

.personage-member {
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;

  .personage-member-a {
    height: 100%;
    width: 90%;
    padding: 0 5%;
    border-top-left-radius: 0.26667rem;
    border-top-right-radius: 0.26667rem;
    background-color: #e9c455;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .van-col {
    float: left;
    box-sizing: border-box;
    min-height: 1px;
  }
}

// 列表区域
.van-cell {
  font-size: 1.06667rem;
  color: #000 !important;
  height: 3.2rem;
  letter-spacing: 0.26667rem;
}

.van-popup .van-icon {
  font-size: 1.2rem;
}

.van-cell__title {
  text-align: left;
  margin-left: 0.4rem;
}

// 切换语言
.personage-cut {
  width: 100%;
  position: fixed;
  bottom: 4rem;
  background-color: #f7f7f7;
  height: 2.66667rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.98667rem;
  color: #004ea3;
}

// 退出登录
.personage-button {
  width: 100%;
  position: fixed;
  bottom: 0.63333rem;

  b {
    font-size: 1.6rem;
    letter-spacing: 0.48rem;
  }
}

.new-feature[data-v-2d9d6322] {
  width: 100%;
  height: 12.44rem;
  background: #1a1a1a;
  border-radius: 2rem;
  padding: 1.16rem;
  overflow: hidden;
  position: relative;
  color: #fff;
}

.left-bg1[data-v-2d9d6322] {
  right: -28.65rem;
  top: -12rem;
}
.left-bg1[data-v-2d9d6322] {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: 0.08;
  transform: rotate(-35deg);
  width: 25.3984rem;
  height: 47.3621rem;
  position: absolute;
}

.banalce-info {
  font-family: DIN Alternate;
  font-style: normal;
  font-weight: 700;
  font-size: 2rem;
  margin-top: 1.2rem;
  border-bottom: 0.01rem solid hsla(0, 0%, 100%, 0.07);
  padding-bottom: 0.8rem;
}

.left-bg2 {
  right: -30.65rem;
  top: -12rem;
}

.left-bg2 {
  background: #d8d8d8;
  mix-blend-mode: normal;
  opacity: 0.08;
  transform: rotate(-35deg);
  width: 25.3984rem;
  height: 47.3621rem;
  position: absolute;
}

.new-feature .titles[data-v-2d9d6322] {
  font-weight: 600;
  //font-size: 0.14rem;
  display: flex;
  justify-content: flex-start;
}

.content .new-feature .titles .balance[data-v-2d9d6322] {
  width: 1.16rem;
  height: 1.16rem;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content[data-v-2d9d6322] {
  width: 100%;
  margin: 3.5rem auto 0;
  border-radius: 0.2rem;
  padding: 1.2rem 1.2rem 5rem 1.2rem;
}
.content .new-feature .infos[data-v-2d9d6322] {
  display: flex;
  justify-content: space-between;
  margin-top: 0.35rem;
}

.content .new-feature .infos .info-title[data-v-2d9d6322] {
  font-weight: 600;
  font-size: 1rem;
  color: #fff;
  opacity: 0.3;
}
.content .new-feature .infos .info-content[data-v-2d9d6322] {
  font-weight: 700;
  font-size: 1.16rem;
  font-family: DIN Alternate;
  margin-top: 0.08rem;
}

.content .strategy[data-v-2d9d6322] {
  height: 20rem;
  background: #1a1a1a;
  border-radius: 1.2rem;
  margin-top: 1.5rem;
  text-align: center;
  padding-top: 3.32rem;
}

.content .strategy .strategy-text[data-v-2d9d6322] {
  font-weight: 600;
  font-size: 1rem;
  color: hsla(0, 0%, 100%, 0.3);
  margin-top: 1rem;
}
.content .strategy .strategy-text1[data-v-2d9d6322] {
  margin-top: 1.1rem;
  font-weight: 600;
  font-size: 1.5rem;
  color: #fff;
}
.content .strategy .strategy-button[data-v-2d9d6322] {
  margin: auto;
  width: 20rem;
  height: 3rem;
  background: #c0dd2b;
  border-radius: 1.13rem;
  color: #000;
  font-weight: 600;
  font-size: 1.16rem;
  text-align: center;
  line-height: 3rem;
  margin-top: 1.5rem;
}
.rersult_succsee {
  color: #c2e22a !important;
  margin-top: 8px;
  text-align: right;
  font-weight: 500;
  font-size: 12px;
}
.rersult[data-v-e6db21c0] {
  font-weight: 500;
  font-size: 12px;
  color: #ce7735;
  margin-top: 8px;
  text-align: right;
}
/deep/ .van-popover__content {
  background-color: #1a1a1a;
  box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);
}
/deep/ .van-popover__action {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: border-box;
  width: 128px;
  height: 44px;
  padding: 0 16px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  background: #1a1a1a;
  color: #fff;
}
</style>
